export default "/static/assets/hg-logo-only-blue.015fe0214c9bf3fa8225b83e511d7f80.svg";